import React, { ComponentProps } from 'react';
import { MembersManage } from '../Members/partials/MembersManage/MembersManage';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { MemberType } from '../../types/api/MemberType';
import { FetchType } from '../../types/api/FetchType';

function TeamRoomMemberRequests(props: { members: MemberType[]; elementType: BlockType }) {
  return (
    <MembersManage
      fetchType={FetchType.instant}
      embedded={{
        members: props.members,
        hideStatus: false,
        elementType: props.elementType,
        pageItems: undefined,
      }}
      href=""
    />
  );
}

export const TeamRoomMemberRequestsBlock = asFetchableBlock(TeamRoomMemberRequests, BlockType.teamroommemberrequests, {
  members: [],
  elementType: BlockType.teamroommemberrequests,
  pageItems: undefined,
});
export type TeamRoomMemberRequestsBlock = ComponentProps<typeof TeamRoomMemberRequestsBlock>;
